<tr class="order-line-status-wrap">
  <td>
    <div class="d-flex justify-content-between">
      <div class="text-bold pre-line">
        {{ orderLine?.name }}
      </div>

      <div class="font-md text-muted mt-1"
           *ngIf="orderLine?.details?.description">
        {{ orderLine?.details?.description }}
      </div>

      <ui-order-line-status-badge
        *ngIf="orderLine.state"
        [status]="orderLine.state"
      ></ui-order-line-status-badge>
    </div>

    <span *ngIf="!isStandardVariant">
      {{ orderLine?.details?.variant?.name }} -
    </span>

    <span *ngIf="isComplex">
      {{ orderLine?.details?.size.value }} {{ orderLine?.details?.measurement }}
    </span>
  </td>

  <td class="text-center valign-top">{{ orderLine.quantity }}</td>

  <ng-container *ngIf="!simplifyView">
    <td class="text-center valign-top">{{ price | currencyFormat: currency }}</td>
    <td class="text-end valign-top">{{ total | currencyFormat: currency }}</td>
  </ng-container>
</tr>
